import { Stack } from '@eventbrite/marmalade';
import { LoadingSkeleton } from '@eventbrite/timed-entry';
import React from 'react';
import styles from './TimeSlotLoadingSkeleton.module.scss';

export const TimeSlotLoadingSkeleton = () => {
    const skeletonItemCount = 6;

    return (
        <Stack space="spacing-md" className={styles.loadingContainer}>
            {Array.from({ length: skeletonItemCount }, (_, i) => (
                <LoadingSkeleton key={i} />
            ))}
        </Stack>
    );
};
